

import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { AccountService } from '../services/account.service';
import { ApiEndpointService } from '../services/api-endpoint.service';

@Injectable()
export class PersonalizationComponentApi {
  constructor(
    private httpService: HttpService,
    private apiEndpoint: ApiEndpointService,
    private accountService: AccountService
  ) {}

  public getPersonalizationAttributes() {
    // console.log('about to get personalization');
    // return this.httpService
    //   .get('assets/personalization-faker.json')
    //   .pipe(delay(100));
    return this.httpService.get(this.apiEndpoint.PersonalAttributesUrl, false, {
      headers: { accountKey: this.accountService.accountKey },
    });
  }
}
